import { SidebarAppConfig } from '@shared/models/app-config.model';
import { RoleByFeature, RoleByPage, RoleBySubfeature } from './roles.config';
import { FEATURES } from './features.config';

export const SIDEBAR_APP_CONFIG: SidebarAppConfig = {
  appName: 'SCE',
  appLicense: '',
  appVersion: '1.0.0',
  menuItems: [
    {
      text: 'menu.home.title',
      isOpen: false,
      isActive: false,
      icon: 'bi bi-house',
      roles: [],
      href: '/home',
      lastPath: 'home',
      isDropdown: false,
      isBadge: false,
      dropdownContent: [],
    },
    {
      text: 'menu.activity.title',
      isOpen: false,
      isActive: false,
      icon: 'bi bi-grid',
      roles: RoleByFeature.ACTIVITY,
      href: '/activity',
      lastPath: 'activity',
      isDropdown: true,
      isBadge: false,
      dropdownContent: [
        {
          text: 'menu.activity.operations.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.OPERATION_BUSINESS,
          href: '/activity/operations',
          lastPath: 'operations',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
        {
          text: 'menu.activity.register-activity.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.REGISTER_ACTIVITY,
          href: '/activity/register-activity',
          lastPath: 'register-activity',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
        {
          text: 'menu.activity.register-interoperable.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.REGISTER_INTEROPERABLES,
          href: '/activity/register-interoperable',
          lastPath: 'register-interoperable',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
        {
          text: 'menu.activity.dashboard-negoci.title',
          isOpen: false,
          isDisabled: true,
          isActive: false,
          roles: [],
          href: '/home',
          lastPath: 'home',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
      ],
    },
    {
      text: 'menu.equipment-management.title',
      isOpen: false,
      isActive: false,
      icon: 'bi bi-layout-text-window',
      roles: RoleByFeature.EQUIPMENT_MANAGEMENT,
      href: '/equipment-management',
      lastPath: 'equipment-management',
      isDropdown: true,
      isBadge: false,
      dropdownContent: [
        {
          text: 'menu.equipment-management.device-monitoring.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.DEVICE_MONITORING,
          href: '/equipment-management/device-monitoring',
          lastPath: 'device-monitoring',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
        {
          text: 'menu.equipment-management.asset-inventory-management.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.ASSET_INVENTORY,
          href: '/equipment-management/asset-inventory-management',
          lastPath: 'asset-inventory-management',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
      ],
    },
    {
      text: 'menu.administration.title',
      isOpen: false,
      isActive: false,
      href: '/administration',
      roles: RoleByFeature.ADMINISTRATION,
      lastPath: 'administration',
      icon: 'bi bi-gear',
      isDropdown: true,
      isBadge: false,
      dropdownContent: [
        {
          text: 'menu.administration.parameters.title',
          isOpen: false,
          isActive: false,
          href: '/administration/parameters',
          lastPath: 'parameters',
          isDropdown: true,
          isBadge: false,
          roles: RoleBySubfeature.PARAMETERS,
          dropdownContent: [
            {
              text: 'menu.administration.parameters.system-parameters.title',
              isOpen: false,
              isActive: false,
              href: '/administration/parameters/system-parameters',
              lastPath: 'system-parameters',
              isDropdown: false,
              isBadge: false,
              roles: RoleByPage.SYSTEM_PARAMETERS,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.parameters.operator-parameters.title',
              isOpen: false,
              isActive: false,
              href: '/administration/parameters/operator-parameters',
              lastPath: 'operator-parameters',
              roles: RoleByPage.OPERATOR_PARAMETERS,
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
          ],
        },
        {
          text: 'menu.administration.users-and-agencies.title',
          isOpen: false,
          isActive: false,
          href: '/administration/users-and-agencies',
          roles: RoleBySubfeature.USER_AND_AGENCIES,
          lastPath: 'users-and-agencies',
          isDropdown: true,
          isBadge: false,
          dropdownContent: [
            {
              text: 'menu.administration.users-and-agencies.agencies.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.AGENCIES,
              href: '/administration/users-and-agencies/agencies',
              lastPath: 'agencies',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.users-and-agencies.sce-users-management.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.USERS_SCE,
              href: '/administration/users-and-agencies/sce-users-management',
              lastPath: 'sce-users-management',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.users-and-agencies.app-users-management.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.USERS_APPS,
              href: '/administration/users-and-agencies/app-users-management',
              lastPath: 'app-users-management',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.users-and-agencies.collaborator-users-management.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.COLLABORATORS,
              href: '/administration/users-and-agencies/collaborator-users-management',
              lastPath: 'collaborator-users-management',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
          ],
        },
        {
          text: 'menu.administration.business-masters.title',
          isOpen: false,
          isActive: false,
          href: '/administration/business-masters',
          lastPath: 'business-masters',
          roles: RoleBySubfeature.BUSINESS_MASTER,
          isDropdown: true,
          isBadge: false,
          dropdownContent: [
            {
              text: 'menu.administration.business-masters.concessions.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.CONCESSIONS,
              href: '/administration/business-masters/concessions',
              lastPath: 'concessions',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.physical-stops.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.PHYSICAL_STOPS,
              href: '/administration/business-masters/physical-stops',
              lastPath: 'physical-stops',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.integrated-lines.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.INTEGRATED_LINES,
              href: '/administration/business-masters/integrated-lines',
              lastPath: 'integrated-lines',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },

            {
              text: 'menu.administration.business-masters.commercial-lines.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.COMMERCIAL_LINE,
              href: '/administration/business-masters/commercial-lines',
              lastPath: 'commercial-lines',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.journeys.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.JOURNEYS,
              href: '/administration/business-masters/journeys',
              lastPath: 'journeys',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.operational-calendar.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.OPERATIONAL_CALENDAR,
              href: '/administration/business-masters/operational-calendar',
              lastPath: 'operational-calendar',
              dropdownContent: [],
              isDropdown: false,
              isBadge: false,
            },
            {
              text: 'menu.administration.business-masters.planned-expeditions.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.EXPEDITIONS,
              href: '/administration/business-masters/planned-expeditions',
              lastPath: 'planned-expeditions',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.versions-visa.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.VERSIONS_VISA,
              href: '/administration/business-masters/versions-visa',
              lastPath: 'versions-visa',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
            },
            {
              text: 'menu.administration.business-masters.own-products.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.OWN_PRODUCTS,
              href: '/administration/business-masters/own-products',
              lastPath: 'own-products',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
            {
              text: 'menu.administration.business-masters.taxes.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.TAXES,
              href: '/administration/business-masters/taxes',
              lastPath: 'taxes',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
            {
              text: 'menu.administration.business-masters.discounts.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.DISCOUNTS,
              href: '/administration/business-masters/discounts',
              lastPath: 'discounts',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
            {
              text: 'menu.administration.business-masters.logical-zones.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.LOGICAL_ZONES,
              href: '/administration/business-masters/logical-zones',
              lastPath: 'logical-zones',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
            {
              text: 'menu.administration.business-masters.rates.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.RATES,
              href: '/administration/business-masters/rates',
              lastPath: 'rates',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
            {
              text: 'menu.administration.business-masters.integrated-products.title',
              isOpen: false,
              isActive: false,
              roles: RoleByPage.INTEGRATED_PRODUCTS,
              href: '/administration/business-masters/integrated-products',
              lastPath: 'integrated-products',
              isDropdown: false,
              isBadge: false,
              dropdownContent: [],
              features: [FEATURES.IT2],
            },
          ],
        },
      ],
    },
    {
      text: 'menu.systemMonitoring.title',
      isOpen: false,
      isActive: false,
      roles: RoleByPage.AWS_MONITORING,
      icon: 'bi bi-activity',
      href: '/system-monitoring',
      lastPath: 'system-monitoring',
      isDropdown: false,
      isBadge: false,
    },
    {
      text: 'menu.audit.title',
      isOpen: false,
      isActive: false,
      roles: RoleByFeature.AUDIT,
      icon: 'bi bi-folder-plus',
      href: '/audit',
      lastPath: 'audit',
      isDropdown: true,
      isBadge: false,
      dropdownContent: [
        {
          text: 'menu.audit.logs-system.title',
          isOpen: false,
          isActive: false,
          roles: RoleByPage.LOGS,
          href: '/audit/logs-system',
          lastPath: 'logs-system',
          isDropdown: false,
          isBadge: false,
          dropdownContent: [],
        },
      ],
    },
  ],
};
